import '../../../resources/styles/treeEditor.css';
import TreeEditor from './TreeEditor';

export default TreeEditor;
